/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/modules/ed-accessibility.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-accessibility.js ***!
  \********************************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  var swatchConfigs = [{
    selector: 'product-variants .variant-swatch-list',
    inputClass: 'input.variant-swatch__radio'
  }, {
    selector: 'product-variants .color-swatch-list',
    inputClass: 'input.color-swatch__radio'
  }, {
    selector: 'product-variants .block-swatch-list',
    inputClass: 'input.block-swatch__radio'
  }];
  swatchConfigs.forEach(function (config) {
    var swatchList = document.querySelector(config.selector);
    if (swatchList) {
      var swatchItems = swatchList.querySelectorAll("".concat(config.selector, " > *"));
      swatchItems.forEach(function (item) {
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && document.activeElement === item) {
            var targetInput = item.querySelector(config.inputClass);
            if (targetInput) {
              var allSwatchInputs = swatchList.querySelectorAll(config.inputClass);
              allSwatchInputs.forEach(function (input) {
                input.checked = false;
              });
              targetInput.checked = true;
              targetInput.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            }
          }
        });
      });
    }
  });
});

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell-item.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-cart-upsell-item.js ***!
  \***********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CartUpsellItem = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartUpsellItem, _HTMLElement);
  var _super = _createSuper(CartUpsellItem);
  function CartUpsellItem() {
    _classCallCheck(this, CartUpsellItem);
    return _super.apply(this, arguments);
  }
  _createClass(CartUpsellItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.listenersAttached) {
        return;
      }
      this.selectedVariantId = null;
      this._attachSelectors();
      this._attachListeners();
      document.addEventListener('drawer:overlay:click', this.closePopover.bind(this));
      this.listenersAttached = true;
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('drawer:overlay:click', this.closePopover.bind(this));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.addEventListener('click', function (event) {
        if (event.target.matches('#overlay') || event.target.matches('.cart-drawer-overlay') || event.target.matches('.drawer__overlay')) {
          _this.closePopover();
        }
      });
      document.addEventListener('ed:variant:selected', function (event) {
        _this.selectedVariantId = event.detail.selectedVariantId;
      });
      this.addEventListener('click', function (event) {
        if (event.target.matches('#AddToCartPopover') || event.target.matches('#atc-btn-text')) {
          _this.addToCart(event);
        }
      });
    }
  }, {
    key: "closePopover",
    value: function closePopover() {
      var popover = document.getElementById('productPopover');
      var cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
      // const needsClick = document.querySelector('.needsclick');
      popover.classList.remove('upsell-shown');
      cartDrawerOverlay.classList.remove('cart-drawer-overlay-shown');
      // needsClick.style.zIndex = '90000';
    }
  }, {
    key: "addToCart",
    value: function addToCart(event) {
      var addToCartBtn = document.getElementById('AddToCartPopover');
      var addToCartBtnText = document.getElementById('atc-btn-text');
      addToCartBtn.setAttribute('ed-loading', 'true');
      addToCartBtnText.style.display = 'none';
      if (!this.selectedVariantId) {
        console.log("Please select a variant.");
        return;
      }
      var isFreeGift = addToCartBtn.dataset.isFreeGift === 'true';
      var cartPayload = _objectSpread({
        id: this.selectedVariantId,
        quantity: 1
      }, isFreeGift && {
        properties: {
          '_free-gift': true
        }
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartPayload)
      }).then(function (response) {
        return response.json();
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
          var response, cart, cartCountElements, popover, cartDrawerOverlay;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                  bubbles: true,
                  detail: {
                    cart: data,
                    openMiniCart: window.themeVariables.settings.cartType === "drawer" && event.target.closest(".drawer") === null
                  }
                }));
                _context.next = 3;
                return fetch('/cart.js');
              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();
              case 6:
                cart = _context.sent;
                cartCountElements = document.querySelectorAll('.header__cart-count');
                cartCountElements.forEach(function (element) {
                  element.innerText = cart.item_count;
                });
                addToCartBtn.removeAttribute('ed-loading');
                popover = document.getElementById('productPopover');
                cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
                addToCartBtnText.style.display = 'none';
                popover.classList.remove('upsell-shown');
                cartDrawerOverlay.classList.remove('cart-drawer-overlay-shown');
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        console.log("Failed to add item to cart.");
      });
    }
  }]);
  return CartUpsellItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-upsell-item', CartUpsellItem);

/***/ }),

/***/ "./src/js/modules/ed-cart-upsell.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-cart-upsell.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CartUpsells = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CartUpsells, _HTMLElement);
  var _super = _createSuper(CartUpsells);
  function CartUpsells() {
    _classCallCheck(this, CartUpsells);
    return _super.apply(this, arguments);
  }
  _createClass(CartUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.listenersAttached) {
        return;
      }
      this.selectedVariantId = null;
      this._attachSelectors();
      this._attachListeners();
      this.listenersAttached = true;
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.upsellAtcButtons = this.querySelectorAll('.upsell-atc-btn');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.upsellAtcButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          return _this.getProductInfo(event);
        });
      });
    }
  }, {
    key: "getProductInfo",
    value: function getProductInfo(event) {
      var target = event.target.closest('.upsell-atc-btn');
      var variants;
      var variantsAttr = target.getAttribute('data-variants');
      if (variantsAttr) {
        variants = JSON.parse(variantsAttr);
      } else {
        var productId = target.getAttribute('data-product-id');
        var variantsScript = this.querySelector("[data-upsell-variants=\"".concat(productId, "\"]"));
        if (!variantsScript) return;
        variants = JSON.parse(variantsScript.textContent);
      }
      var productInfo = {
        title: target.getAttribute('data-title'),
        image: target.getAttribute('data-image'),
        price: target.getAttribute('data-price'),
        url: target.getAttribute('data-url'),
        compareAtPrice: target.getAttribute('data-compare-at-price'),
        variants: variants,
        isFreeGift: target.closest('.milestone-item') !== null
      };
      this.populatePopover(productInfo);
    }
  }, {
    key: "populatePopover",
    value: function populatePopover(productInfo) {
      var _this2 = this;
      document.getElementById('popoverTitle').textContent = productInfo.title;
      document.getElementById('popoverImage').src = productInfo.image;
      document.getElementById('popoverPrice').textContent = productInfo.price;
      document.getElementById('popoverUrl').href = productInfo.url;
      document.getElementById('AddToCartPopover').dataset.isFreeGift = productInfo.isFreeGift ? 'true' : '';
      if (productInfo.compareAtPrice > productInfo.price) {
        document.getElementById('popoverCompareAtPrice').textContent = productInfo.compareAtPrice;
      }
      var variantSelectContainer = document.getElementById('popoverVariants');
      variantSelectContainer.innerHTML = '';
      var optionNames = ['option1', 'option2', 'option3'];
      optionNames.forEach(function (optionName) {
        var optionValues = _toConsumableArray(new Set(productInfo.variants.map(function (variant) {
          return variant[optionName];
        })));
        if (optionValues[0] !== null) {
          var div = document.createElement('div');
          var select = document.createElement('select');
          div.classList.add('upsell-select-wrapper');
          select.name = optionName;
          select.id = optionName;
          var label = "Option";
          if (/\d/.test(optionValues[0])) {
            label = "Größe";
          } else {
            label = "Farbe";
          }
          var labelText = document.createElement('label');
          labelText.setAttribute('for', optionName);
          labelText.textContent = label;
          optionValues.forEach(function (value) {
            var option = document.createElement('option');
            option.value = value;
            option.text = value;
            var matchingVariant = productInfo.variants.find(function (variant) {
              return variant[optionName] === value;
            });
            if (matchingVariant) {
              option.setAttribute('data-variant-id', matchingVariant.id);
            }
            var self = _this2;
            select.addEventListener('change', function () {
              var selectedOption = this.options[this.selectedIndex];
              self.selectedVariantId = selectedOption.getAttribute('data-variant-id');
              updateSelectedVariant(productInfo);
            });
            select.appendChild(option);
          });
          div.appendChild(select);
          variantSelectContainer.appendChild(labelText);
          variantSelectContainer.appendChild(div);
        }
      });
      updateSelectedVariant(productInfo);
      showPopover();
    }
  }]);
  return CartUpsells;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-cart-upsells', CartUpsells);
function showPopover() {
  var popover = document.getElementById('productPopover');
  var cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
  // const needsClick = document.querySelector('.needsclick');
  popover.classList.add('upsell-shown');
  cartDrawerOverlay.classList.add('cart-drawer-overlay-shown');
  // needsClick.style.zIndex = '0';
  document.dispatchEvent(new CustomEvent('ed:cart:open'));
}
function updateSelectedVariant(productInfo) {
  var selectedOptions = {};
  ['option1', 'option2', 'option3'].forEach(function (optionName) {
    var selectElement = document.getElementById(optionName);
    if (selectElement) {
      selectedOptions[optionName] = selectElement.options[selectElement.selectedIndex].value;
    }
  });
  var matchingVariant = productInfo.variants.find(function (variant) {
    return Object.keys(selectedOptions).every(function (optionName) {
      return variant[optionName] === selectedOptions[optionName];
    });
  });
  if (matchingVariant) {
    this.selectedVariantId = matchingVariant.id;
    document.dispatchEvent(new CustomEvent('ed:variant:selected', {
      detail: {
        selectedVariantId: this.selectedVariantId
      }
    }));
    updateAddToCartButton(matchingVariant.available);
  } else {
    updateAddToCartButton(false);
  }
}
function updateAddToCartButton(isVariantExist) {
  var addToCartBtn = document.getElementById('AddToCartPopover');
  if (isVariantExist) {
    addToCartBtn.removeAttribute('disabled');
  } else {
    addToCartBtn.setAttribute('disabled', 'disabled');
  }
}
document.addEventListener('ed:cart:open', function () {
  var drawerOverlay = document.querySelector('.drawer__overlay');
  drawerOverlay.addEventListener('click', function () {
    var event = new CustomEvent('drawer:overlay:click');
    document.dispatchEvent(event);
  });
});

/***/ }),

/***/ "./src/js/modules/ed-color-swatch-gallery.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-color-swatch-gallery.js ***!
  \***************************************************/
/***/ (() => {

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * Color Swatch Gallery Module
 * Adds color swatches to the .pwzrswiper-wrapper element
 * Displays first two color swatches + count of remaining variants
 */

// Global flag to prevent multiple initializations
var isInitialized = false;

// Track styles added by this module for proper cleanup
var moduleStyles = [];

// Localization helper function
function getLocalizedText(key, fallback) {
  // Get from data attributes on the product section
  var productSection = document.querySelector('.product');
  if (productSection) {
    var dataKey = key.replace(/\./g, '-');
    var dataValue = productSection.getAttribute("data-".concat(dataKey));
    if (dataValue) return dataValue;
  }

  // Fallback to provided fallback
  return fallback || key;
}
document.addEventListener('DOMContentLoaded', function () {
  if (isInitialized) {
    return;
  }
  var targetNode = document.querySelector('.product-form__option-value');
  if (targetNode) {
    isInitialized = true;
    initColorSwatchGallery();
  }
}, false);
function initColorSwatchGallery() {
  // Check if already initialized
  if (document.querySelector('.ed-color-swatch-gallery')) {
    return;
  }

  // Check screen width - only execute for screens under 1000px
  if (window.innerWidth >= 1000) {
    return;
  }

  // Check if product has variants - only execute for products with variants
  if (!hasProductVariants()) {
    return;
  }

  // Check if product has color variants (not just size variants)
  if (!hasColorVariants()) {
    return;
  }

  // Debounce timer
  var debounceTimer;

  // Function to be called when elements are found
  function handleElementsExistence() {
    // Clear existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    // Set new timer to prevent multiple rapid executions
    debounceTimer = setTimeout(function () {
      var pwzrWrapper = document.querySelector('#pwzrswiper-wrapper');
      if (pwzrWrapper && !pwzrWrapper.querySelector('.ed-color-swatch-gallery')) {
        // Check if Rio gallery has slides loaded
        var slides = pwzrWrapper.querySelectorAll('.pwzrswiper-slide');
        if (slides.length > 0) {
          createColorSwatchGallery(pwzrWrapper);
        }
      }
    }, 100); // 100ms debounce
  }

  // Create a MutationObserver instance
  var observer = new MutationObserver(function (mutationsList, observer) {
    // Check if any mutations are related to the appearance of the desired elements
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'childList') {
          handleElementsExistence();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial check with a delay to ensure Rio gallery is loaded
  setTimeout(function () {
    handleElementsExistence();
  }, 1000);

  // Handle window resize to show/hide feature based on screen size
  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      var existingGallery = document.querySelector('.ed-color-swatch-gallery');
      if (window.innerWidth >= 1000 && existingGallery) {
        // Remove gallery if screen is now >= 1000px
        existingGallery.remove();
      } else if (window.innerWidth < 1000 && !existingGallery) {
        // Add gallery if screen is now < 1000px and no gallery exists
        handleElementsExistence();
      }
    }, 250);
  });
}
function createColorSwatchGallery(pwzrWrapper) {
  // Check if gallery already exists to prevent multiple executions
  if (pwzrWrapper.querySelector('.ed-color-swatch-gallery')) {
    return;
  }

  // Get variant count from Liquid data attributes (most reliable)
  var productVariantsElement = document.querySelector('.product-form__variants');
  if (!productVariantsElement) {
    return;
  }
  var totalCount = parseInt(productVariantsElement.getAttribute('data-variant-count')) || 0;
  var availableCount = parseInt(productVariantsElement.getAttribute('data-available-variant-count')) || 0;
  if (availableCount <= 1) {
    return; // No need to show swatches if there's only one variant
  }

  // Create the color swatch gallery element
  var colorSwatchGallery = document.createElement('button');
  colorSwatchGallery.className = 'prd-MediaCarousel_ColourSwatch ed-color-swatch-gallery';
  colorSwatchGallery.setAttribute('data-colour-swatch-btn', '');

  // Get product variants for color extraction
  var productVariants = getProductVariants();
  var firstTwoVariants = productVariants ? productVariants.slice(0, 2) : [];
  var totalAvailableCount = availableCount; // Use Liquid count directly

  // Create SVG with color swatches
  var svg = createColorSwatchSVG(firstTwoVariants);
  colorSwatchGallery.appendChild(svg);

  // Create text span
  var textSpan = document.createElement('span');
  // Get localized text for "Colors"
  var localizedColorsText = getLocalizedText('product.color_swatch_gallery.colors_available', document.documentElement.lang === 'de' ? 'Farben' : 'Colors');
  textSpan.innerHTML = "+".concat(totalAvailableCount, " <span>").concat(localizedColorsText, "</span>");
  colorSwatchGallery.appendChild(textSpan);

  // Add click handler to open variant modal
  colorSwatchGallery.addEventListener('click', function () {
    openVariantModal();
  });

  // Position the element
  colorSwatchGallery.style.cssText = "\n        position: absolute;\n        bottom: 43px;\n        right: 14px;\n        z-index: 1;\n        background: #fff;\n        border: 1px solid;\n        border-radius: 18px;\n        padding: 8px 12px;\n        display: none;\n        align-items: center;\n        gap: 8px;\n        cursor: pointer;\n        line-height: normal;\n        transition: opacity 0.3s ease, transform 0.3s ease;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    ";

  // Add slide change detection
  setupSlideChangeDetection(pwzrWrapper, colorSwatchGallery);

  // Add vibrant animation to signal clickability
  addVibrantAnimation(colorSwatchGallery);

  // Append to the wrapper
  pwzrWrapper.style.position = 'relative';
  pwzrWrapper.appendChild(colorSwatchGallery);
}
function createColorSwatchSVG(variants) {
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('width', '32');
  svg.setAttribute('height', '20');
  svg.setAttribute('viewBox', '0 0 32 20');
  svg.setAttribute('fill', 'none');

  // Get actual colors from variants
  var colors = getActualColorsFromVariants(variants);

  // Create only 2 circles with actual colors
  for (var i = 0; i < 2; i++) {
    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    var cx = 10 + i * 12; // Position circles at 10 and 22
    circle.setAttribute('cx', cx);
    circle.setAttribute('cy', '10');
    circle.setAttribute('r', '9.5');
    circle.setAttribute('stroke', 'white');
    circle.setAttribute('fill', colors[i] || '#999999');
    svg.appendChild(circle);
  }
  return svg;
}
function getActualColorsFromVariants(variants) {
  // Get colors from the rendered snippet
  var colorSwatchData = document.querySelector('.ed-color-swatch-data');
  var colors = [];
  if (colorSwatchData) {
    var colorItems = colorSwatchData.querySelectorAll('.ed-color-swatch-item');
    for (var i = 0; i < Math.min(2, colorItems.length); i++) {
      var item = colorItems[i];
      var colorHex = item.getAttribute('data-color-hex');
      if (colorHex) {
        colors.push(colorHex);
      } else {
        // Fallback to color name mapping
        var colorName = item.getAttribute('data-color-name');
        var color = getColorFromName(colorName);
        colors.push(color || '#999999');
      }
    }
  }

  // If we still don't have enough colors, try to get from available variants
  var availableVariants = variants.filter(function (variant) {
    return variant.available !== false;
  });
  while (colors.length < 2 && availableVariants.length > colors.length) {
    var variant = availableVariants[colors.length];
    var _color = getVariantColor(variant);
    colors.push(_color);
  }

  // Ensure we have at least 2 colors
  while (colors.length < 2) {
    colors.push('#999999');
  }
  return colors.slice(0, 2); // Return only first 2 colors
}

function rgbToHex(rgb) {
  var result = rgb.match(/\d+/g);
  if (!result || result.length < 3) return '#999999';
  var r = parseInt(result[0]);
  var g = parseInt(result[1]);
  var b = parseInt(result[2]);
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function getVariantColor(variant) {
  // Try to get color from variant title or option values
  var title = variant.title || '';
  var options = variant.options || [];

  // Look for color in options
  var _iterator2 = _createForOfIteratorHelper(options),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var option = _step2.value;
      if (option && typeof option === 'string') {
        var _color2 = getColorFromName(option);
        if (_color2) return _color2;
      }
    }

    // Look for color in title
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var color = getColorFromName(title);
  if (color) return color;

  // Default fallback
  return '#999999';
}
function getColorFromName(name) {
  if (!name) return null;
  var nameLower = name.toLowerCase();

  // Color mapping based on common German color names
  var colorMap = {
    'schwarz': '#000000',
    'black': '#000000',
    'weiß': '#ffffff',
    'weiss': '#ffffff',
    'white': '#ffffff',
    'grau': '#919191',
    'grey': '#919191',
    'gray': '#919191',
    'burgundy': '#691c2e',
    'burgund': '#691c2e',
    'sand': '#ebe2dc',
    'beige': '#ebe2dc',
    'olive-grau': '#6b7c32',
    'olive': '#6b7c32',
    'hellgrau': '#cccccc',
    'light grey': '#cccccc',
    'dunkelgrau': '#666666',
    'dark grey': '#666666',
    'rot': '#d12231',
    'red': '#d12231',
    'blau': '#36558c',
    'blue': '#36558c',
    'royal blau': '#36558c',
    'royal blue': '#36558c',
    'grün': '#72ce52',
    'green': '#72ce52',
    'gelb': '#ffaa2d',
    'yellow': '#ffaa2d',
    'rosa': '#f39da6',
    'pink': '#f39da6',
    'dunkel beige': '#dab9a0',
    'dark beige': '#dab9a0',
    'mix': '#999999',
    'multi': '#999999'
  };

  // Check for exact matches first
  if (colorMap[nameLower]) {
    return colorMap[nameLower];
  }

  // Check for partial matches
  for (var _i = 0, _Object$entries = Object.entries(colorMap); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (nameLower.includes(key)) {
      return value;
    }
  }
  return null;
}
function addVibrantAnimation(colorSwatchGallery) {
  // Add CSS animation keyframes
  var style = document.createElement('style');
  style.setAttribute('data-module', 'ed-color-swatch-gallery');
  style.textContent = "\n        @keyframes ed-color-swatch-pulse {\n            0% {\n                transform: scale(1);\n                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n            }\n            50% {\n                transform: scale(1.02);\n                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n            }\n            100% {\n                transform: scale(1);\n                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n            }\n        }\n        \n        @keyframes ed-color-swatch-bounce {\n            0%, 20%, 50%, 80%, 100% {\n                transform: translateY(0) scale(1);\n            }\n            40% {\n                transform: translateY(-4px) scale(1.01);\n            }\n            60% {\n                transform: translateY(-2px) scale(1.005);\n            }\n        }\n        \n        @keyframes ed-color-swatch-glow {\n            0% {\n                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(59, 130, 246, 0.3);\n            }\n            50% {\n                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2), 0 0 0 6px rgba(59, 130, 246, 0.08);\n            }\n            100% {\n                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(59, 130, 246, 0);\n            }\n        }\n        \n        .ed-color-swatch-gallery {\n            animation: ed-color-swatch-pulse 4s ease-in-out infinite;\n        }\n        \n        .ed-color-swatch-gallery:hover {\n            animation: ed-color-swatch-bounce 1.2s ease-in-out;\n        }\n        \n        .ed-color-swatch-gallery.attention-grab {\n            animation: ed-color-swatch-glow 3s ease-in-out infinite;\n        }\n        \n        .ed-color-swatch-gallery svg circle {\n            animation: ed-color-swatch-circle-pulse 4s ease-in-out infinite;\n        }\n        \n        .ed-color-swatch-gallery svg circle:nth-child(2) {\n            animation-delay: 0.8s;\n        }\n        \n        @keyframes ed-color-swatch-circle-pulse {\n            0%, 100% {\n                transform: scale(1);\n            }\n            50% {\n                transform: scale(1.05);\n            }\n        }\n        \n        .ed-color-swatch-gallery span {\n            animation: ed-color-swatch-text-shimmer 6s ease-in-out infinite;\n        }\n        \n        @keyframes ed-color-swatch-text-shimmer {\n            0%, 100% {\n                opacity: 1;\n            }\n            50% {\n                opacity: 0.9;\n            }\n        }\n    ";
  document.head.appendChild(style);

  // Track this style for cleanup
  moduleStyles.push(style);

  // Add attention-grabbing class after a delay
  setTimeout(function () {
    colorSwatchGallery.classList.add('attention-grab');

    // Remove attention-grabbing class after 12 seconds (slower)
    setTimeout(function () {
      colorSwatchGallery.classList.remove('attention-grab');
    }, 12000);
  }, 2000);

  // Add hover effects (more subtle)
  colorSwatchGallery.addEventListener('mouseenter', function () {
    this.style.transform = 'scale(1.02)';
    this.style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.18)';
  });
  colorSwatchGallery.addEventListener('mouseleave', function () {
    this.style.transform = 'scale(1)';
    this.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
  });

  // Add click animation (more subtle)
  colorSwatchGallery.addEventListener('mousedown', function () {
    this.style.transform = 'scale(0.98)';
  });
  colorSwatchGallery.addEventListener('mouseup', function () {
    this.style.transform = 'scale(1.02)';
  });
}
function setupSlideChangeDetection(pwzrWrapper, colorSwatchGallery) {
  var lastSlideState = null;
  var throttleTimer = null;

  // Function to check current slide and show/hide gallery
  function checkCurrentSlide() {
    // Throttle the function to prevent excessive calls
    if (throttleTimer) {
      return;
    }
    throttleTimer = setTimeout(function () {
      throttleTimer = null;
    }, 100);
    var slides = pwzrWrapper.querySelectorAll('.pwzrswiper-slide, .swiper-slide');
    var activeSlide = pwzrWrapper.querySelector('.pwzrswiper-slide-active, .swiper-slide-active, .pwzrswiper-slide[aria-hidden="false"]');
    if (slides.length > 0) {
      // Show gallery only on first slide
      var isFirstSlide = activeSlide === slides[0] || !activeSlide || slides[0].classList.contains('pwzrswiper-slide-active');
      var currentState = isFirstSlide ? 'first' : 'other';

      // Only update if state actually changed
      if (lastSlideState !== currentState) {
        lastSlideState = currentState;
        if (isFirstSlide) {
          colorSwatchGallery.style.opacity = '1';
          colorSwatchGallery.style.pointerEvents = 'auto';
        } else {
          colorSwatchGallery.style.opacity = '0';
          colorSwatchGallery.style.pointerEvents = 'none';
        }
      }
    }
  }

  // Initial check
  checkCurrentSlide();

  // Set initial state
  lastSlideState = 'first'; // Assume first slide initially

  // Listen for slide changes using multiple methods
  // Method 1: Listen for Swiper events
  var swiperContainer = pwzrWrapper.closest('.swiper-container, .swiper') || pwzrWrapper;

  // Try to find Swiper instance
  var swiperInstance = null;
  if (swiperContainer.swiper) {
    swiperInstance = swiperContainer.swiper;
  } else if (window.Swiper && swiperContainer.querySelector('.swiper-wrapper')) {
    // Try to find Swiper instance by looking for swiper data
    var swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (swiperWrapper && swiperWrapper.swiper) {
      swiperInstance = swiperWrapper.swiper;
    }
  }
  if (swiperInstance) {
    swiperInstance.on('slideChange', checkCurrentSlide);
    swiperInstance.on('slideChangeTransitionEnd', checkCurrentSlide);
  } else {
    // Method 2: Listen for Rio gallery specific events
    pwzrWrapper.addEventListener('transitionend', checkCurrentSlide);
    pwzrWrapper.addEventListener('animationend', checkCurrentSlide);

    // Method 3: Use MutationObserver to watch for class changes
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && (mutation.attributeName === 'class' || mutation.attributeName === 'aria-hidden')) {
          checkCurrentSlide();
        }
      });
    });

    // Observe all slides for class changes
    var slides = pwzrWrapper.querySelectorAll('.pwzrswiper-slide, .swiper-slide');
    slides.forEach(function (slide) {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    });

    // Method 4: Listen for touch/click events that might change slides (throttled)
    var touchTimer = null;
    pwzrWrapper.addEventListener('touchstart', function () {
      if (touchTimer) return;
      touchTimer = setTimeout(function () {
        checkCurrentSlide();
        touchTimer = null;
      }, 200);
    });
    var clickTimer = null;
    pwzrWrapper.addEventListener('click', function () {
      if (clickTimer) return;
      clickTimer = setTimeout(function () {
        checkCurrentSlide();
        clickTimer = null;
      }, 200);
    });

    // Method 5: Polling as fallback (reduced frequency)
    setInterval(checkCurrentSlide, 2000);
  }
}
function hasProductVariants() {
  // Check if there are any variant options in the product form
  var variantOptions = document.querySelectorAll('.product-form__option-selector');
  if (variantOptions.length > 0) {
    return true;
  }

  // Check if there are existing color swatches
  var existingSwatches = document.querySelectorAll('.color-swatch__radio');
  if (existingSwatches.length > 0) {
    return true;
  }

  // Check if there are variant images
  var variantImages = document.querySelectorAll('.variant-swatch');
  if (variantImages.length > 0) {
    return true;
  }
  return false;
}
function hasColorVariants() {
  // Check for variant-image selector type (color variants with images)
  var variantImageSelectors = document.querySelectorAll('.product-form__option-selector[data-selector-type="variant-image"]');
  if (variantImageSelectors.length > 0) {
    return true;
  }

  // Check for color selector type (color swatches)
  var colorSelectors = document.querySelectorAll('.product-form__option-selector[data-selector-type="color"]');
  if (colorSelectors.length > 0) {
    return true;
  }
  return false;
}

// Cache for variants to prevent multiple calculations
var variantsCache = null;
var cacheTimestamp = 0;
var CACHE_DURATION = 10000; // 10 seconds

function getProductVariants() {
  // Check cache first
  var now = Date.now();
  if (variantsCache && now - cacheTimestamp < CACHE_DURATION) {
    return variantsCache;
  }

  // First, try to get variant count from Liquid data attributes (most reliable)
  var productVariantsElement = document.querySelector('.product-form__variants');
  if (productVariantsElement) {
    var totalCount = parseInt(productVariantsElement.getAttribute('data-variant-count')) || 0;
    var availableCount = parseInt(productVariantsElement.getAttribute('data-available-variant-count')) || 0;
    if (totalCount > 0) {
      // Create variants array based on Liquid data
      var variants = [];

      // Get variant swatches for color extraction
      var _variantSwatches = document.querySelectorAll('.variant-swatch-list .variant-swatch__radio');
      var colorSwatches = document.querySelectorAll('.color-swatch-list .color-swatch__radio');

      // Use variant swatches if available, otherwise color swatches
      var swatches = _variantSwatches.length > 0 ? _variantSwatches : colorSwatches;
      for (var i = 0; i < Math.min(availableCount, swatches.length); i++) {
        var swatch = swatches[i];
        // Only include available variants
        if (!swatch.disabled) {
          variants.push({
            id: swatch.value || "variant-".concat(i),
            title: swatch.value || "Variant ".concat(i + 1),
            options: [swatch.value || "Variant ".concat(i + 1)],
            available: true
          });
        }
      }

      // Cache the result
      variantsCache = variants;
      cacheTimestamp = now;
      return variants;
    }
  }

  // Fallback: try to get variants from variant swatches (legacy method)
  var variantSwatches = document.querySelectorAll('.variant-swatch-list .variant-swatch__radio');
  if (variantSwatches.length > 0) {
    // Create a Set to ensure unique values
    var uniqueVariants = new Set();
    var _variants = [];
    Array.from(variantSwatches).forEach(function (swatch) {
      var value = swatch.value;
      if (value && !uniqueVariants.has(value)) {
        uniqueVariants.add(value);
        _variants.push({
          id: value,
          title: value,
          options: [value],
          available: !swatch.disabled
        });
      }
    });

    // Cache the result
    variantsCache = _variants;
    cacheTimestamp = now;
    return _variants;
  }
  return null;
}
function openVariantModal() {
  // Check if modal already exists
  if (document.querySelector('.ed-color-swatch-modal')) {
    return;
  }

  // Create overlay
  var overlay = document.createElement('div');
  overlay.className = 'ed-color-swatch-overlay';
  overlay.style.cssText = "\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0, 0, 0, 0.5);\n        z-index: 9998;\n        opacity: 0;\n        transition: opacity 0.4s ease;\n    ";

  // Create modal
  var modal = document.createElement('div');
  modal.className = 'ed-color-swatch-modal';
  modal.style.cssText = "\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100vw;\n        background: #fff;\n        border-radius: 20px 20px 0 0;\n        z-index: 9999;\n        transform: translateY(100%);\n        transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n        padding: 20px;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        max-height: 80vh;\n        min-height: 200px;\n    ";

  // Create header
  var header = document.createElement('div');
  header.style.cssText = "\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n        padding-bottom: 15px;\n        border-bottom: 1px solid #e0e0e0;\n    ";
  var title = document.createElement('h3');
  // Get localized text - fallback to language detection
  var localizedTitle = getLocalizedText('product.color_swatch_gallery.choose_color', document.documentElement.lang === 'de' ? 'Farbe wählen' : 'Choose color');
  title.textContent = localizedTitle;
  title.style.cssText = "\n        margin: 0;\n        font-size: 18px;\n        font-weight: 600;\n        color: #333;\n    ";
  var closeBtn = document.createElement('button');
  closeBtn.innerHTML = "\n        <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M18 6L6 18M6 6L18 18\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        </svg>\n    ";
  closeBtn.style.cssText = "\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 8px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #666;\n        transition: background-color 0.2s ease;\n    ";
  closeBtn.addEventListener('mouseenter', function () {
    this.style.backgroundColor = '#f5f5f5';
  });
  closeBtn.addEventListener('mouseleave', function () {
    this.style.backgroundColor = 'transparent';
  });
  closeBtn.addEventListener('click', function () {
    closeVariantModal();
  });
  header.appendChild(title);
  header.appendChild(closeBtn);

  // Create content area
  var content = document.createElement('div');
  content.className = 'ed-color-swatch-content';
  content.style.cssText = "\n        flex: 1;\n        padding: 0;\n        overflow: visible;\n    ";

  // Create a simplified color-only variant selector instead of cloning
  var existingVariants = document.querySelector('.product-form__variants');
  if (existingVariants) {
    // Find only the color variant selector
    var colorSelector = existingVariants.querySelector('.product-form__option-selector[data-selector-type="variant-image"]');
    if (colorSelector) {
      var clonedColorSelector = colorSelector.cloneNode(true);
      clonedColorSelector.style.cssText = "\n                border: none;\n                padding: 0;\n                margin: 0;\n            ";

      // Add custom styles for the modal variant options
      var style = document.createElement('style');
      style.setAttribute('data-module', 'ed-color-swatch-gallery');
      style.textContent = "\n            .ed-color-swatch-modal {\n                transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;\n            }\n            .ed-color-swatch-overlay {\n                transition: opacity 0.4s ease !important;\n            }\n            .ed-color-swatch-modal .product-form__option-selector {\n                margin-bottom: 20px;\n            }\n            .ed-color-swatch-modal .product-form__option-info {\n                margin-bottom: 12px;\n            }\n            .ed-color-swatch-modal .product-form__option-name {\n                font-weight: 600;\n                color: #333;\n                font-size: 16px;\n            }\n            .ed-color-swatch-modal .color-swatch-list {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 12px;\n            }\n            .ed-color-swatch-modal .color-swatch {\n                width: 50px;\n                height: 50px;\n                border-radius: 50%;\n                border: 2px solid #e0e0e0;\n                cursor: pointer;\n                transition: all 0.2s ease;\n            }\n            .ed-color-swatch-modal .color-swatch:hover {\n                transform: scale(1.1);\n                border-color: #333;\n            }\n            .ed-color-swatch-modal .color-swatch__item {\n                width: 100%;\n                height: 100%;\n                border-radius: 50%;\n                display: block;\n            }\n            .ed-color-swatch-modal .block-swatch-list {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 8px;\n            }\n            .ed-color-swatch-modal .block-swatch {\n                border: 2px solid #e0e0e0;\n                border-radius: 8px;\n                cursor: pointer;\n                transition: all 0.2s ease;\n            }\n            .ed-color-swatch-modal .block-swatch:hover {\n                border-color: #333;\n            }\n            .ed-color-swatch-modal .block-swatch__item {\n                padding: 12px 16px;\n                display: block;\n                font-size: 14px;\n                font-weight: 500;\n            }\n            .ed-color-swatch-modal .color-swatch:has(input:disabled),\n            .ed-color-swatch-modal .block-swatch:has(input:disabled) {\n                opacity: 0.5;\n                cursor: not-allowed;\n                pointer-events: none;\n            }\n            .ed-color-swatch-modal .color-swatch input:disabled + .color-swatch__item,\n            .ed-color-swatch-modal .block-swatch input:disabled + .block-swatch__item {\n                opacity: 0.5;\n                cursor: not-allowed;\n            }\n        ";
      document.head.appendChild(style);

      // Track this style for cleanup
      moduleStyles.push(style);

      // Add event listeners to the cloned variant elements and disable unavailable ones
      var clonedInputs = clonedColorSelector.querySelectorAll('input[type="radio"]');
      var clonedLabels = clonedColorSelector.querySelectorAll('label.variant-swatch__item');

      // Add click listeners to inputs
      clonedInputs.forEach(function (input, index) {
        // Check if this variant is available
        var originalInputs = document.querySelectorAll('.product-form__option-selector[data-selector-type="variant-image"] input[type="radio"]');
        var originalInput = originalInputs[index];
        if (originalInput && originalInput.disabled) {
          // Disable unavailable variants
          input.disabled = true;
          input.parentElement.style.opacity = '0.5';
          input.parentElement.style.cursor = 'not-allowed';
          input.parentElement.title = 'This variant is not available';
        }
        input.addEventListener('click', function (event) {
          // Prevent any scrolling behavior
          event.preventDefault();
          event.stopPropagation();

          // Don't allow selection of disabled variants
          if (this.disabled) {
            return;
          }
          if (originalInput && !originalInput.disabled) {
            // Check the original input
            originalInput.checked = true;

            // Trigger change event on original input
            var changeEvent = new Event('change', {
              bubbles: true,
              cancelable: true
            });
            originalInput.dispatchEvent(changeEvent);

            // Close modal immediately
            closeVariantModal();
          }
        });
      });

      // Add click listeners to labels
      clonedLabels.forEach(function (label, index) {
        label.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          // Find the corresponding original input by index
          var originalInputs = document.querySelectorAll('.product-form__option-selector[data-selector-type="variant-image"] input[type="radio"]');
          if (originalInputs[index] && !originalInputs[index].disabled) {
            // Check the original input
            originalInputs[index].checked = true;

            // Trigger change event on original input
            var changeEvent = new Event('change', {
              bubbles: true,
              cancelable: true
            });
            originalInputs[index].dispatchEvent(changeEvent);

            // Close modal immediately
            closeVariantModal();
          }
        });
      });
      content.appendChild(clonedColorSelector);
    } else {
      // Fallback: create simple color swatches
      var productVariants = getProductVariants();
      if (productVariants && productVariants.length > 0) {
        var swatchContainer = document.createElement('div');
        swatchContainer.style.cssText = "\n                    display: grid;\n                    grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));\n                    gap: 15px;\n                ";
        productVariants.slice(0, 6).forEach(function (variant) {
          var swatch = document.createElement('button');
          swatch.className = 'variant-swatch';
          swatch.style.cssText = "\n                        border: 2px solid #e0e0e0;\n                        border-radius: 8px;\n                        padding: 8px;\n                        background: white;\n                        cursor: pointer;\n                        transition: all 0.2s ease;\n                    ";
          swatch.innerHTML = "\n                        <div style=\"width: 100%; height: 60px; background: #f0f0f0; border-radius: 4px; margin-bottom: 8px;\"></div>\n                        <div style=\"font-size: 12px; color: #333;\">".concat(variant.title, "</div>\n                    ");
          swatch.addEventListener('click', function () {
            // Find and trigger the original variant
            var originalInput = document.querySelector("input[value=\"".concat(variant.title, "\"]"));
            if (originalInput) {
              originalInput.checked = true;
              originalInput.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            }
            closeVariantModal();
          });
          swatchContainer.appendChild(swatch);
        });
        content.appendChild(swatchContainer);
      }
    }
  }

  // Assemble modal
  modal.appendChild(header);
  modal.appendChild(content);

  // Add to DOM (initially hidden)
  document.body.appendChild(overlay);
  document.body.appendChild(modal);

  // Prevent body scroll and store current scroll position
  var currentScrollY = window.scrollY;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = "-".concat(currentScrollY, "px");
  document.body.style.width = '100%';

  // Calculate and set optimal height before animation
  calculateModalHeight(modal);

  // Ensure modal starts in correct position for smooth animation
  modal.style.transform = 'translateY(100%)';

  // Trigger animations with proper timing
  setTimeout(function () {
    overlay.style.opacity = '1';
    modal.style.transform = 'translateY(0)';
  }, 10);

  // Close on overlay click
  overlay.addEventListener('click', function () {
    closeVariantModal();
  });
}
function calculateModalHeight(modal) {
  // Create a temporary clone for measurement
  var tempModal = modal.cloneNode(true);
  tempModal.style.cssText = "\n        position: absolute;\n        top: -9999px;\n        left: 0;\n        width: 100vw;\n        height: auto;\n        visibility: hidden;\n        transform: none;\n        z-index: -1;\n    ";

  // Add to DOM temporarily
  document.body.appendChild(tempModal);

  // Get the content height
  var content = tempModal.querySelector('.ed-color-swatch-content');
  var header = tempModal.querySelector('div:first-child');
  var contentHeight = 0;
  var headerHeight = 0;
  if (content) {
    contentHeight = content.scrollHeight;
  }
  if (header) {
    headerHeight = header.offsetHeight;
  }

  // Remove temporary modal
  document.body.removeChild(tempModal);

  // Calculate total height needed
  var padding = 40; // 20px top + 20px bottom
  var totalHeight = headerHeight + contentHeight + padding;

  // Set constraints
  var maxHeight = window.innerHeight * 0.8; // 80% of viewport height
  var minHeight = 200;
  var finalHeight = Math.max(minHeight, Math.min(totalHeight, maxHeight));

  // Apply the calculated height to the original modal
  modal.style.height = "".concat(finalHeight, "px");

  // If content is taller than available space, make it scrollable
  if (content && contentHeight > finalHeight - headerHeight - padding) {
    var originalContent = modal.querySelector('.ed-color-swatch-content');
    if (originalContent) {
      originalContent.style.overflowY = 'auto';
      originalContent.style.maxHeight = "".concat(finalHeight - headerHeight - padding, "px");
    }
  }
}
function closeVariantModal() {
  var overlay = document.querySelector('.ed-color-swatch-overlay');
  var modal = document.querySelector('.ed-color-swatch-modal');
  if (overlay && modal) {
    // Animate out
    overlay.style.opacity = '0';
    modal.style.transform = 'translateY(100%)';

    // Remove elements after animation
    setTimeout(function () {
      overlay.remove();
      modal.remove();

      // Restore body scroll and position
      var scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);

      // Clean up only the module's styles
      moduleStyles.forEach(function (style) {
        if (style && style.parentNode) {
          style.remove();
        }
      });
      moduleStyles = []; // Clear the tracking array
    }, 300);
  }
}

/***/ }),

/***/ "./src/js/modules/ed-free-gift-handling.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-free-gift-handling.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FreeGiftHandling = /*#__PURE__*/function (_HTMLElement) {
  _inherits(FreeGiftHandling, _HTMLElement);
  var _super = _createSuper(FreeGiftHandling);
  function FreeGiftHandling() {
    _classCallCheck(this, FreeGiftHandling);
    return _super.apply(this, arguments);
  }
  _createClass(FreeGiftHandling, [{
    key: "cartType",
    get: function get() {
      return this.getAttribute('cart-type');
    }
  }, {
    key: "discountType",
    get: function get() {
      return this.getAttribute('discount-type');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.debugMode = false; // Change this value as needed
      this.isGiftAlreadyInCart = this.getAttribute('gift-already-in-cart');
      this._attachListeners();
      this._attachSelectors();
      if (this.cartType === 'drawer') {
        document.addEventListener('cart:updated', this.onCartChange.bind(this));
        if (this.progressBar) {
          setTimeout(function () {
            // make sure cartTotal and threshold are updated
            document.addEventListener('cart:updated', _this.initProgressBar.bind(_this));
          });
        }
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartTotal = this.getAttribute('cart-total');
      this.threshold = this.getAttribute('threshold');
      this.eligibleProducts = this.getAttribute('eligible-products-ids');
      this.freeGiftItems = this.getAttribute('free-gift-ids');
      if (this.discountType === 'minimum_quantity') {
        this.cartQuantity = this.getAttribute('cart-quantity'); // important note: this attribute is only made for counting eligible products
      }

      /** Progress Bar **/
      document.addEventListener('ed:progress-bar:loaded', function () {
        // need to wait for the progress bar to load
        this.progressBar = document.querySelector('ed-free-gift-progress-bar');
        if (this.progressBar) {
          this.initProgressBar();
        }
      }.bind(this));
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('DOMContentLoaded', this.initFreeGifts.bind(this));
    }
  }, {
    key: "onCartChange",
    value: function onCartChange(e) {
      var cart = e.detail.cart;
      var freeGiftItemsTotal = cart.items.filter(function (item) {
        return item.properties && item.properties['_free-gift'];
      }).reduce(function (sum, item) {
        return sum + item.final_line_price;
      }, 0);
      this.cartTotal = cart.total_price - freeGiftItemsTotal;
      if (this.discountType === 'minimum_quantity') {
        this.cartQuantity = this.countEligibleCartQuantity(cart.items, this.eligibleProducts);
      }
      this.isGiftAlreadyInCart = this.checkIsGiftAlreadyInCart(cart.items);
      this.initFreeGifts();
    }
  }, {
    key: "checkIsGiftAlreadyInCart",
    value: function checkIsGiftAlreadyInCart(cartItems) {
      var freeGiftIds = this.freeGiftItems.split(',');
      return cartItems.some(function (item) {
        return freeGiftIds.includes(item.id.toString()) && item.properties && item.properties['_free-gift'];
      });
    }
  }, {
    key: "initFreeGifts",
    value: function initFreeGifts() {
      var isThresholdReached;
      switch (this.discountType) {
        case 'minimum_price':
          isThresholdReached = this.isMinimumPriceReached(this.cartTotal, this.threshold);
          break;
        case 'minimum_quantity':
          isThresholdReached = this.isMinimumQuantityReached(this.cartQuantity, this.threshold);
          break;
      }
      if (!isThresholdReached && this.isGiftAlreadyInCart) {
        this.removeFreeGifts(this.freeGiftItems);
      }
      if (sessionStorage.getItem('ed_free_gift_added') && !this.debugMode) {
        return;
      }
      if (!isThresholdReached || this.isGiftAlreadyInCart) {
        return;
      }

      // Enable this, if you want to add the gift automatically
      // this.addFreeGifts(this.freeGiftItems);
    }
  }, {
    key: "isMinimumPriceReached",
    value: function isMinimumPriceReached(cartTotal, threshold) {
      return parseInt(cartTotal) >= parseInt(threshold);
    }
  }, {
    key: "isMinimumQuantityReached",
    value: function isMinimumQuantityReached(cartQuantity, minimumQuantity) {
      return parseInt(cartQuantity) >= parseInt(minimumQuantity);
    }
  }, {
    key: "countEligibleCartQuantity",
    value: function countEligibleCartQuantity(cartItems, eligibleProducts) {
      if (!eligibleProducts) {
        return;
      }
      eligibleProducts = eligibleProducts.split(',');
      var totalEligibleQuantity = 0;

      // Iterate over each item in cartItems
      cartItems.forEach(function (item) {
        // Check if the current item's ID is in the eligibleProducts array
        if (eligibleProducts.includes(item.id.toString())) {
          // Add the item's quantity to the total eligible quantity
          totalEligibleQuantity += item.quantity;
        }
      });
      return totalEligibleQuantity;
    }
  }, {
    key: "addFreeGifts",
    value: function addFreeGifts(items) {
      var _this2 = this;
      var itemIds = items.split(',');
      var itemAdd = [];
      itemIds.forEach(function (id) {
        var item = {
          id: id,
          quantity: 1,
          properties: {
            '_free-gift': true
          }
        };
        itemAdd.push(item);
      });
      var formData = {
        'items': itemAdd,
        quantity: 1
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(formData),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (addedItemsData) {
        _this2.onFreeGiftAdded(addedItemsData);
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }, {
    key: "removeFreeGifts",
    value: function removeFreeGifts(items) {
      var _this3 = this;
      if (this._isRemovingGifts) return;
      this._isRemovingGifts = true;
      var itemIds = items.split(',');
      var updates = {};
      itemIds.forEach(function (id) {
        updates[id] = 0;
      });
      var attemptRemove = function attemptRemove() {
        var retries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
        fetch("/cart/update.js", {
          body: JSON.stringify({
            updates: updates
          }),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (response) {
          if (response.status === 409 && retries > 0) {
            setTimeout(function () {
              return attemptRemove(retries - 1);
            }, 500);
            return null;
          }
          if (!response.ok) throw new Error("cart/update.js failed with status ".concat(response.status));
          return response.json();
        }).then(function (updatedCartData) {
          if (!updatedCartData) return;
          _this3.isGiftAlreadyInCart = false;
          _this3.onFreeGiftRemoved(updatedCartData);
        })["catch"](function (e) {
          console.error(e);
        })["finally"](function () {
          _this3._isRemovingGifts = false;
        });
      };
      attemptRemove();
    }
  }, {
    key: "onFreeGiftAdded",
    value: function onFreeGiftAdded(addedItemsData) {
      // IF ADDED ITEMS IS FREE GIFT, CHANGE THE PROPERTY
      this.cartQuantity = this.cartQuantity + this.countEligibleCartQuantity(addedItemsData === null || addedItemsData === void 0 ? void 0 : addedItemsData.items, this.eligibleProducts);
      this.isGiftAlreadyInCart = this.checkIsGiftAlreadyInCart(addedItemsData.items);
      if (this.cartType === 'drawer') {
        setTimeout(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:build', {
            bubbles: true
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
        }, 1000);
      } else {
        location.reload();
      }
      this.setSessionStorageItem('ed_free_gift_added', 'true');
    }
  }, {
    key: "onFreeGiftRemoved",
    value: function onFreeGiftRemoved(updatedCartData) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart: updatedCartData
        }
      }));
    }
  }, {
    key: "setSessionStorageItem",
    value: function setSessionStorageItem(key, value) {
      sessionStorage.setItem(key, value);
    }

    /** PROGRESS BAR **/
  }, {
    key: "initProgressBar",
    value: function initProgressBar() {
      var isThresholdReached;
      switch (this.discountType) {
        case 'minimum_price':
          isThresholdReached = this.isMinimumPriceReached(this.cartTotal, this.threshold);
          break;
        case 'minimum_quantity':
          isThresholdReached = this.isMinimumQuantityReached(this.cartQuantity, this.threshold);
          break;
      }
      this.milestoneItem = this.progressBar.querySelector('.milestone-item');
      if (!this.isGiftAlreadyInCart && isThresholdReached) {
        this.milestoneItem.classList.add('active');
        this.milestoneItem.addEventListener('click', this.mileStoneItemClickListener.bind(this));
      } else {
        this.milestoneItem.classList.remove('active');
        this.milestoneItem.removeEventListener('click', this.mileStoneItemClickListener.bind(this));
      }
    }

    // Enable this, to reinstate the original atc for milestones
  }, {
    key: "mileStoneItemClickListener",
    value: function mileStoneItemClickListener() {
      // this.addFreeGifts(this.freeGiftItems);
    }
  }]);
  return FreeGiftHandling;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-handling', FreeGiftHandling);
var FreeGiftProgressBar = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(FreeGiftProgressBar, _HTMLElement2);
  var _super2 = _createSuper(FreeGiftProgressBar);
  function FreeGiftProgressBar() {
    _classCallCheck(this, FreeGiftProgressBar);
    return _super2.apply(this, arguments);
  }
  _createClass(FreeGiftProgressBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachListeners();
      this._attachSelectors();
      document.dispatchEvent(new CustomEvent('ed:progress-bar:loaded'));
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {}
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {}
  }]);
  return FreeGiftProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-free-gift-progress-bar', FreeGiftProgressBar);

/***/ }),

/***/ "./src/js/modules/ed-hide-pdp-images.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-hide-pdp-images.js ***!
  \**********************************************/
/***/ (() => {

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  function modifySliderMapping() {
    if (!window.__productWizRioVariantImages || !window.__productWizRioVariantImages.mapping) {
      // console.log('Rio variant images not found');
      return;
    }
    if (!window.__productWizRioProduct) {
      // console.log('Product data not found');
      return;
    }
    var hidePdpElement = document.getElementById('hide-pdp-images');
    if (!hidePdpElement) {
      // console.log('hide-pdp-images element not found');
      return;
    }
    var isVariantA = false;
    if (window.ablyft) {
      var activeExperiments = window.ablyft.get('activeExperimentIds');
      // console.log('ABlyft active experiments:', activeExperiments);

      if (activeExperiments && activeExperiments[55457504] === 29664724) {
        isVariantA = true;
      }
    }
    var variantsConfig = JSON.parse(hidePdpElement.textContent);
    var hideKey = isVariantA ? 'hide_images_a' : 'hide_images_b';
    console.log("Modifying slider mapping for variant ".concat(isVariantA ? 'A' : 'B'));
    window.__productWizRioVariantImages.mapping.forEach(function (variantMapping) {
      var productVariant = window.__productWizRioProduct.variants.find(function (v) {
        return String(v.id) === String(variantMapping.id);
      });
      if (!productVariant) {
        // console.log('Could not find product variant for ID:', variantMapping.id);
        return;
      }
      var variantTitle = productVariant.option1 || productVariant.title;
      var variantConfig = variantsConfig.find(function (v) {
        return v.title === variantTitle;
      });
      if (variantConfig && variantConfig[hideKey]) {
        var hidePositions = JSON.parse(variantConfig[hideKey]);
        var originalMedia = _toConsumableArray(variantMapping.media);
        var hideMediaIds = hidePositions.map(function (pos) {
          return originalMedia[pos - 1];
        }).filter(function (id) {
          return id;
        });
        variantMapping.media = variantMapping.media.filter(function (mediaId) {
          return !hideMediaIds.includes(mediaId);
        });

        // console.log(`Variant ${variantTitle}: Removed ${hideMediaIds.length} images, ${variantMapping.media.length} remaining`);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', modifySliderMapping);
  } else {
    modifySliderMapping();
  }
})();
document.addEventListener('DOMContentLoaded', function () {
  var targetNode = document.querySelector('.product-form__option-value');
  if (targetNode) {
    sliderObserver(targetNode);
  }
}, false);
function sliderObserver(targetNode) {
  function handleElementsExistence() {
    var elements = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
    if (elements.length > 0) {
      variantChange(targetNode);
      getJson();
      observer.disconnect();
    }
  }
  var observer = new MutationObserver(function (mutationsList, observer) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;
        if (mutation.type === 'childList') {
          handleElementsExistence();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  handleElementsExistence();
}
function variantChange(targetNode) {
  function handleMutation(mutationsList, observer) {
    var _iterator2 = _createForOfIteratorHelper(mutationsList),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var mutation = _step2.value;
        if (mutation.type === 'childList') {
          getJson();
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  var config = {
    childList: true,
    characterData: true,
    subtree: true
  };
  var observer = new MutationObserver(handleMutation);
  observer.observe(targetNode, config);
}
function getJson() {
  var variants = document.getElementById('hide-pdp-images').textContent;
  var variantsObj = JSON.parse(variants);
  var activeVariants = document.querySelectorAll('.product-form__option-value');
  var activeVariant;
  if (activeVariants.length > 1) {
    activeVariants.forEach(function (variant, index) {
      if (index == 0) {
        activeVariant = variant.textContent;
      } else {
        activeVariant = activeVariant + ' / ' + variant.textContent;
      }
    });
  } else {
    activeVariant = activeVariants[0].textContent;
  }
  var matchingVariant = variantsObj.find(function (variant) {
    return variant.title === activeVariant;
  });
  if (matchingVariant) {
    var info_button = matchingVariant.info_button;
    parseInfoButtonData("".concat(info_button));
  }
}
function parseInfoButtonData(data) {
  var segments = data.split(/,(?=1|0\|)/);
  var parsedData = segments.map(function (segment) {
    var _segment$split = segment.split("|"),
      _segment$split2 = _slicedToArray(_segment$split, 4),
      active = _segment$split2[0],
      imageNumber = _segment$split2[1],
      title = _segment$split2[2],
      text = _segment$split2[3];
    return {
      active: parseInt(active, 10) === 1,
      imageNumber: parseInt(imageNumber, 10),
      title: title,
      text: text
    };
  });
  addInfoButton(parsedData);
}
function addInfoButton(data) {
  var mainSlider = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
  data.forEach(function (obj) {
    if (obj.active) {
      var infoWrapper = document.createElement('div');
      infoWrapper.classList.add('ed-info-button__wrapper');
      var titleSpan = document.createElement('div');
      titleSpan.classList.add('ed-info-button__title');
      titleSpan.textContent = obj.title;
      infoWrapper.appendChild(titleSpan);
      if (obj.text !== undefined && typeof obj.text === 'string' && obj.text.length > 1) {
        var textSpan = document.createElement('div');
        textSpan.classList.add('ed-info-button__text');
        textSpan.textContent = obj.text;
        var moreInfo = document.createElement('div');
        moreInfo.classList.add('ed-info-button__more-info');
        var infoIcon = document.createElement('div');
        infoIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>';
        moreInfo.appendChild(infoIcon);
        infoWrapper.appendChild(moreInfo);
        infoWrapper.appendChild(textSpan);
      }
      var imageNumber = parseInt(obj.imageNumber - 1);
      if (mainSlider[imageNumber]) {
        mainSlider[imageNumber].appendChild(infoWrapper);
      }
    }
  });
  openInfoButtonDialog();
}
function openInfoButtonDialog() {
  var btns = document.querySelectorAll(".ed-info-button__more-info");
  btns.forEach(function (btn) {
    var text = btn.parentNode.querySelector(".ed-info-button__text");
    var showText = function showText() {
      text.classList.add("show");
    };
    var hideText = function hideText() {
      text.classList.remove("show");
    };
    btn.addEventListener("mouseenter", showText);
    btn.addEventListener("mouseleave", hideText);
    btn.addEventListener("click", showText);
    btn.addEventListener("touchstart", showText);
    btn.addEventListener("touchend", hideText);
  });
}

/***/ }),

/***/ "./src/js/modules/ed-reviews-sync.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-reviews-sync.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ReviewsSync = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ReviewsSync, _HTMLElement);
  var _super = _createSuper(ReviewsSync);
  function ReviewsSync() {
    _classCallCheck(this, ReviewsSync);
    return _super.apply(this, arguments);
  }
  _createClass(ReviewsSync, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (this.listenersAttached) {
        return;
      }
      this.init();
      this.listenersAttached = true;
    }
  }, {
    key: "init",
    value: function init() {
      // Start retry logic
      this.attemptSync(0);
    }
  }, {
    key: "attemptSync",
    value: function attemptSync(attempt) {
      var _this = this;
      var maxAttempts = 5;
      var delay = 500;
      setTimeout(function () {
        var success = _this.syncReviewsCount();
        if (!success && attempt < maxAttempts) {
          _this.attemptSync(attempt + 1);
        }
      }, delay);
    }
  }, {
    key: "syncReviewsCount",
    value: function syncReviewsCount() {
      try {
        // Try hidden widget first, then fall back to visible widget
        var widgetId = null;
        var hiddenWidget = document.querySelector('#reviewsio-hidden-widget');
        var visibleWidget = document.querySelector('#reviewsio-carousel-widget');
        if (hiddenWidget) {
          widgetId = '#reviewsio-hidden-widget';
        } else if (visibleWidget) {
          widgetId = '#reviewsio-carousel-widget';
        } else {
          return false;
        }
        var widgetNumbers = document.querySelectorAll("".concat(widgetId, " .cssVar-subheading__number"));
        var widgetStars = document.querySelector("".concat(widgetId, " .R-RatingStars__stars"));
        if (widgetNumbers && widgetNumbers.length > 1 && widgetStars) {
          var rating = widgetNumbers[0].innerHTML.trim();
          var count = widgetNumbers[1].innerHTML.trim();
          var starsHtml = widgetStars.innerHTML.trim();

          // Only sync if we have valid data
          if (rating && count && count !== '0' && count !== '' && starsHtml) {
            // Update review count
            var edReviewsNumbers = document.querySelectorAll('.ed-reviews-number');
            edReviewsNumbers.forEach(function (element) {
              element.innerHTML = count;
            });

            // Update rating
            var edReviewsRating = document.querySelectorAll('.ed-reviews-rating');
            edReviewsRating.forEach(function (element) {
              element.innerHTML = rating;
            });

            // Update stars (convert Reviews.io icons to Font Awesome)
            var edReviewsStars = document.querySelectorAll('.ed-reviews-stars');
            var faStarsHtml = this.convertToFontAwesome(starsHtml);
            edReviewsStars.forEach(function (element) {
              element.innerHTML = faStarsHtml;
            });
            return true; // Success
          }
        }

        return false; // Not ready yet
      } catch (error) {
        // Silently fail to avoid breaking other parts of the shop
        console.warn('ReviewsSync: Error syncing reviews', error);
        return false;
      }
    }
  }, {
    key: "convertToFontAwesome",
    value: function convertToFontAwesome(reviewsIoHtml) {
      try {
        // Convert Reviews.io star icons to Font Awesome
        var faHtml = reviewsIoHtml;
        faHtml = faHtml.replace(/ricon-percentage-star--100/g, 'fa fa-star');
        faHtml = faHtml.replace(/stars__icon--50/g, 'fa-star-half');
        faHtml = faHtml.replace(/stars__icon--0/g, '');
        faHtml = faHtml.replace(/<i class="stars__icon\s*"><\/i>/g, '');
        return faHtml;
      } catch (error) {
        console.warn('ReviewsSync: Error converting stars', error);
        return reviewsIoHtml; // Return original if conversion fails
      }
    }
  }]);
  return ReviewsSync;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-reviews-sync', ReviewsSync);

/***/ }),

/***/ "./src/js/modules/ed-round-corner.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-round-corner.js ***!
  \*******************************************/
/***/ (() => {

function adjustEdCorner(element) {
  var alignment = element.getAttribute('ed-corner');
  if (!alignment || alignment === 'none') {
    element.style.borderTopLeftRadius = '';
    element.style.borderTopRightRadius = '';
    element.style.borderBottomLeftRadius = '';
    element.style.borderBottomRightRadius = '';
    return;
  }
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  var X, radiusValue;
  if (width > height) {
    X = (1 - (width - height + height / 2) / width) * 100;
    radiusValue = "".concat(X, "% 50%");
  } else {
    X = (1 - (height - width + width / 2) / height) * 100;
    radiusValue = "50% ".concat(X, "%");
  }
  element.style.borderTopLeftRadius = '';
  element.style.borderTopRightRadius = '';
  element.style.borderBottomLeftRadius = '';
  element.style.borderBottomRightRadius = '';
  if (alignment === 'top-left') {
    element.style.borderTopLeftRadius = radiusValue;
  } else if (alignment === 'top-right') {
    element.style.borderTopRightRadius = radiusValue;
  } else if (alignment === 'bottom-left') {
    element.style.borderBottomLeftRadius = radiusValue;
  } else if (alignment === 'bottom-right') {
    element.style.borderBottomRightRadius = radiusValue;
  }
}
var resizeObserver = new ResizeObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.target.hasAttribute('ed-corner')) {
      adjustEdCorner(entry.target);
    }
  });
});
function initializeEdCorners() {
  document.querySelectorAll('[ed-corner]').forEach(function (element) {
    element.style.overflow = 'hidden';
    resizeObserver.observe(element);
    adjustEdCorner(element);
  });
}
window.addEventListener('DOMContentLoaded', initializeEdCorners);
window.addEventListener('resize', initializeEdCorners);

/***/ }),

/***/ "./src/js/modules/ed-slideshow.js":
/*!****************************************!*\
  !*** ./src/js/modules/ed-slideshow.js ***!
  \****************************************/
/***/ (() => {

function adjustSlideshow(element) {
  var slide = element.querySelector('.slideshow__slide-inner');
  if (slide) {
    var alignment = slide.parentNode.dataset.alignment;
    if (alignment === 'none') {
      return;
    }
    var width = slide.offsetWidth;
    var height = slide.offsetHeight;
    var X, radiusValue;
    if (width > height) {
      X = (1 - (width - height + height / 2) / width) * 100;
      radiusValue = "".concat(X, "% 50%");
    } else {
      X = (1 - (height - width + width / 2) / height) * 100;
      radiusValue = "50% ".concat(X, "%");
    }
    slide.style.borderTopLeftRadius = '';
    slide.style.borderTopRightRadius = '';
    slide.style.borderBottomLeftRadius = '';
    slide.style.borderBottomRightRadius = '';
    if (alignment === 'top-left') {
      slide.style.borderTopLeftRadius = radiusValue;
    } else if (alignment === 'top-right') {
      slide.style.borderTopRightRadius = radiusValue;
    } else if (alignment === 'bottom-left') {
      slide.style.borderBottomLeftRadius = radiusValue;
    } else if (alignment === 'bottom-right') {
      slide.style.borderBottomRightRadius = radiusValue;
    }
  }
}
document.addEventListener('adjust-slideshow', function (event) {
  var element = event.detail.element;
  adjustSlideshow(element);
});
var resizeObserver = new ResizeObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.target.classList.contains('slideshow__slide-inner')) {
      adjustSlideshow(entry.target);
    }
  });
});
document.querySelectorAll('.slideshow__slide-inner').forEach(function (block) {
  resizeObserver.observe(block);
});

/***/ }),

/***/ "./src/js/modules/ed-upsell.js":
/*!*************************************!*\
  !*** ./src/js/modules/ed-upsell.js ***!
  \*************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Upsell = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Upsell, _HTMLElement);
  var _super = _createSuper(Upsell);
  function Upsell() {
    _classCallCheck(this, Upsell);
    return _super.apply(this, arguments);
  }
  _createClass(Upsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.initRating();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this$productForm;
      this.variants = this.querySelectorAll(".ed-upsell__card-variant li");
      this.customDropdowns = this.querySelectorAll(".ed-upsell__custom-dropdown");
      this.image = this.querySelector('.ed-upsell__card-img img');
      this.color = this.querySelector('.ed-upsell__card-variant span');
      this.price = this.querySelector('.ed-upsell__price');
      this.url = this.querySelector('a.ed-upsell__btn');
      this.atc = this.querySelector('button.ed-upsell__btn');
      this.stars = this.querySelectorAll('.ed-upsell__rating .star');
      this.numRatings = this.querySelector('.ed-upsell__rating span');
      this.sizes = this.querySelectorAll('.ed-upsell__sizes li');
      this.products = this.querySelectorAll('.ed-upsell__card-variant ul');
      this.title = this.querySelector('#ed-upsell__title');
      this.ratings = this.getAttribute('data-ratings');
      this.checkbox = this.querySelector('.ed-upsell__checkbox');
      this.productForm = document.querySelector('.product-form__buy-buttons form');
      this.mainProductIdInput = (_this$productForm = this.productForm) === null || _this$productForm === void 0 ? void 0 : _this$productForm.querySelector('input[name="id"]');
      this.activeDropdown = null;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.variants.forEach(function (variant) {
        variant.addEventListener('click', function (e) {
          _this.getVariantInfos(e);
          _this.setActiveVariant(e);
        });
      });
      this.customDropdowns.forEach(function (dropdown) {
        var button = dropdown.querySelector('.ed-upsell__dropdown-button');
        var options = dropdown.querySelector('.ed-upsell__dropdown-options');
        var optionItems = dropdown.querySelectorAll('.ed-upsell__dropdown-option');
        button.addEventListener('click', function (e) {
          e.stopPropagation();
          _this.toggleDropdown(dropdown);
        });
        optionItems.forEach(function (option) {
          option.addEventListener('click', function (e) {
            if (option.classList.contains('is-selected')) {
              return;
            }
            e.stopPropagation();
            _this.selectDropdownOption(dropdown, option);
          });
        });
      });
      document.addEventListener('click', function () {
        _this.closeAllDropdowns();
      });
      window.addEventListener('scroll', function () {
        if (_this.activeDropdown) {
          _this.updateDropdownPosition(_this.activeDropdown);
        }
      }, {
        passive: true
      });
      window.addEventListener('resize', function () {
        if (_this.activeDropdown) {
          _this.updateDropdownPosition(_this.activeDropdown);
        }
      });
      this.sizes.forEach(function (size) {
        size.addEventListener('click', function (e) {
          _this.getActiveSize(e);
          _this.setActiveSize(e);
        });
      });
      if (this.atc) {
        this.atc.addEventListener('click', function (e) {
          _this.addToCart(e);
        });
      }
      if (this.checkbox) {
        this.checkbox.addEventListener('change', function (e) {
          _this.handleCheckboxChange(e);
        });
      }
    }
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(e) {
      var variantId = this.checkbox.getAttribute('data-current-variant');
      var isChecked = e.target.checked;
      if (isChecked) {
        this.modifyFormForMultipleItems(variantId);
      } else {
        this.restoreOriginalForm();
      }
    }
  }, {
    key: "modifyFormForMultipleItems",
    value: function modifyFormForMultipleItems(upsellVariantId) {
      if (!this.mainProductIdInput) return;
      var mainProductVariantId = this.mainProductIdInput.value;
      this.mainProductIdInput.name = 'items[0][id]';
      var existingUpsellInput = this.productForm.querySelector('input[name="items[1][id]"]');
      if (existingUpsellInput) {
        existingUpsellInput.value = upsellVariantId;
      } else {
        var upsellInput = document.createElement('input');
        upsellInput.type = 'hidden';
        upsellInput.name = 'items[1][id]';
        upsellInput.value = upsellVariantId;
        this.mainProductIdInput.insertAdjacentElement('afterend', upsellInput);
      }
      var existingUpsellQtyInput = this.productForm.querySelector('input[name="items[1][quantity]"]');
      if (!existingUpsellQtyInput) {
        var upsellQtyInput = document.createElement('input');
        upsellQtyInput.type = 'hidden';
        upsellQtyInput.name = 'items[1][quantity]';
        upsellQtyInput.value = '1';
        this.productForm.querySelector('input[name="items[1][id]"]').insertAdjacentElement('afterend', upsellQtyInput);
      }
    }
  }, {
    key: "restoreOriginalForm",
    value: function restoreOriginalForm() {
      if (!this.mainProductIdInput) return;
      this.mainProductIdInput.name = 'id';
      var upsellInput = this.productForm.querySelector('input[name="items[1][id]"]');
      if (upsellInput) {
        upsellInput.remove();
      }
      var upsellQtyInput = this.productForm.querySelector('input[name="items[1][quantity]"]');
      if (upsellQtyInput) {
        upsellQtyInput.remove();
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown(dropdown) {
      var button = dropdown.querySelector('.ed-upsell__dropdown-button');
      var options = dropdown.querySelector('.ed-upsell__dropdown-options');
      var isOpen = options.classList.contains('is-open');
      this.closeAllDropdowns();
      if (!isOpen) {
        button.classList.add('is-open');
        options.classList.add('is-open');
        this.activeDropdown = dropdown;
        this.updateDropdownPosition(dropdown);
      }
    }
  }, {
    key: "updateDropdownPosition",
    value: function updateDropdownPosition(dropdown) {
      var button = dropdown.querySelector('.ed-upsell__dropdown-button');
      var options = dropdown.querySelector('.ed-upsell__dropdown-options');
      var buttonRect = button.getBoundingClientRect();
      options.style.top = "".concat(buttonRect.bottom, "px");
      options.style.left = "".concat(buttonRect.left, "px");
      options.style.width = "".concat(buttonRect.width, "px");
    }
  }, {
    key: "closeAllDropdowns",
    value: function closeAllDropdowns() {
      this.customDropdowns.forEach(function (dropdown) {
        var button = dropdown.querySelector('.ed-upsell__dropdown-button');
        var options = dropdown.querySelector('.ed-upsell__dropdown-options');
        button.classList.remove('is-open');
        options.classList.remove('is-open');
      });
      this.activeDropdown = null;
    }
  }, {
    key: "selectDropdownOption",
    value: function selectDropdownOption(dropdown, option) {
      var button = dropdown.querySelector('.ed-upsell__dropdown-button span');
      var allOptions = dropdown.querySelectorAll('.ed-upsell__dropdown-option');
      var wrapper = dropdown.parentElement;
      var label = wrapper.getAttribute('data-label');
      allOptions.forEach(function (opt) {
        return opt.classList.remove('is-selected');
      });
      option.classList.add('is-selected');
      var variantTitle = option.textContent.trim();
      if (label) {
        button.innerHTML = "<strong>".concat(label, ":</strong> ").concat(variantTitle);
      } else {
        button.textContent = variantTitle;
      }
      var id = option.getAttribute('data-variantId');
      var handle = option.getAttribute('data-handle');
      var src = option.getAttribute('data-src');
      var price = option.getAttribute('data-price');
      var comparePrice = option.getAttribute('data-compare-price');
      var url = option.getAttribute('data-url');
      var sku = option.getAttribute('data-sku');
      var title = option.getAttribute('data-title');
      this.setVariantInfos(id, handle, src, price, comparePrice, url, sku, title);
      this.closeAllDropdowns();
    }
  }, {
    key: "initRating",
    value: function initRating() {
      if (this.ratings) {
        if (this.customDropdowns.length > 0) {
          var firstDropdown = this.customDropdowns[0];
          var firstOption = firstDropdown.querySelector('.ed-upsell__dropdown-option');
          var sku = firstOption.getAttribute('data-sku');
          if (this.ratings) {
            this.getReviews(sku);
          }
        } else {
          var firstVariant = this.variants[0].querySelector('img');
          var _sku = firstVariant.getAttribute('data-sku');
          if (this.ratings) {
            this.getReviews(_sku);
          }
        }
      }
    }
  }, {
    key: "getVariantInfos",
    value: function getVariantInfos(e) {
      var id = e.srcElement.getAttribute('data-variantId');
      var handle = e.srcElement.getAttribute('alt');
      var src = e.srcElement.getAttribute('src');
      var price = e.srcElement.getAttribute('data-price');
      var comparePrice = e.srcElement.getAttribute('data-compare-compare');
      var url = e.srcElement.getAttribute('data-url');
      var sku = e.srcElement.getAttribute('data-sku');
      var title = e.srcElement.getAttribute('data-title');
      this.setVariantInfos(id, handle, src, price, comparePrice, url, sku, title);
    }
  }, {
    key: "setVariantInfos",
    value: function setVariantInfos(id, handle, src, price, comparePrice, url, sku, title) {
      if (this.atc) {
        this.atc.setAttribute('data-id', id);
      }
      if (this.checkbox) {
        this.checkbox.setAttribute('data-current-variant', id);
        if (this.checkbox.checked) {
          this.modifyFormForMultipleItems(id);
        }
      }
      this.image.setAttribute('src', src);
      if (this.price) {
        if (comparePrice && comparePrice !== '' && comparePrice !== '0' && comparePrice !== price) {
          this.price.innerHTML = "<span class=\"price price--compare\">".concat(comparePrice, "</span><span class=\"price price--highlight\">").concat(price, "</span>");
        } else {
          this.price.innerHTML = "<span class=\"price\">".concat(price, "</span>");
        }
      }
      if (this.url) {
        this.url.setAttribute('href', url);
      }
      var testTitle = this.querySelector('.ed-upsell__title');
      testTitle.textContent = title;
      this.getReviews(sku);
    }
  }, {
    key: "setActiveVariant",
    value: function setActiveVariant(e) {
      this.variants.forEach(function (variant) {
        variant.setAttribute('data-active', false);
        if (variant == e.srcElement.parentElement) {
          variant.setAttribute('data-active', true);
        }
      });
    }
  }, {
    key: "getActiveSize",
    value: function getActiveSize(e) {
      this.setActiveProductVariants(e.srcElement.getAttribute('data-handle'));
    }
  }, {
    key: "setActiveSize",
    value: function setActiveSize(e) {
      this.sizes.forEach(function (size) {
        size.setAttribute('data-active', false);
        if (size == e.srcElement) {
          size.setAttribute('data-active', true);
        }
      });
    }
  }, {
    key: "setActiveProductVariants",
    value: function setActiveProductVariants(handle) {
      var _this2 = this;
      if (this.customDropdowns.length > 0) {
        var wrappers = this.querySelectorAll('.ed-upsell__dropdown-wrapper');
        wrappers.forEach(function (wrapper) {
          wrapper.style.display = 'none';
          if (wrapper.getAttribute('data-handle') == handle) {
            wrapper.style.display = 'block';
            var dropdown = wrapper.querySelector('.ed-upsell__custom-dropdown');
            var firstOption = dropdown.querySelector('.ed-upsell__dropdown-option');
            _this2.selectDropdownOption(dropdown, firstOption);
          }
        });
      } else {
        this.products.forEach(function (product) {
          product.setAttribute('data-active', false);
          if (product.getAttribute('data-handle') == handle) {
            product.setAttribute('data-active', true);
            var firstVariant = document.querySelector('.ed-upsell__card-variant ul[data-active="true"] li img');
            firstVariant.click();
          }
        });
      }
    }
  }, {
    key: "getReviews",
    value: function getReviews(sku) {
      var _this3 = this;
      var options = {
        method: 'GET',
        headers: {
          accept: 'application/json'
        }
      };
      fetch("https://api.reviews.io/product/rating-batch?store=johnny-urban&sku=".concat(sku), options).then(function (response) {
        return response.json();
      }).then(function (data) {
        return _this3.setReviews(data[0].average_rating, data[0].num_ratings);
      })["catch"](function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "setReviews",
    value: function setReviews(rating, num) {
      if (!this.stars) return;
      var fullStars = Math.floor(rating);
      var hasHalfStar = rating % 1 >= 0.5;
      var halfStarIndex = hasHalfStar ? fullStars : -1;
      this.stars.forEach(function (star, index) {
        star.classList.remove('star-filled', 'star-half', 'star-empty');
        if (index < fullStars) {
          star.classList.add('star-filled');
        } else if (index === halfStarIndex) {
          star.classList.add('star-half');
        } else {
          star.classList.add('star-empty');
        }
      });
      this.numRatings.textContent = '(' + num + ')';
    }
  }, {
    key: "addToCart",
    value: function addToCart(e) {
      var id = e.srcElement.getAttribute('data-id');
      var formData = {
        'items': [{
          'id': id,
          'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
          var response, cart, cartCountElements;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                  detail: {
                    cart: data,
                    openMiniCart: window.themeVariables.settings.cartType === "drawer" && e.target.closest(".drawer") === null
                  }
                }));
                _context.next = 3;
                return fetch('/cart.js');
              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();
              case 6:
                cart = _context.sent;
                cartCountElements = document.querySelectorAll('.header__cart-count');
                cartCountElements.forEach(function (element) {
                  element.innerText = cart.item_count;
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        console.error('Error:', error);
      });
    }
  }]);
  return Upsell;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-upsell', Upsell);

/***/ }),

/***/ "./src/js/modules/ed-video.js":
/*!************************************!*\
  !*** ./src/js/modules/ed-video.js ***!
  \************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdVideo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideo, _HTMLElement);
  var _super = _createSuper(EdVideo);
  function EdVideo() {
    _classCallCheck(this, EdVideo);
    return _super.apply(this, arguments);
  }
  _createClass(EdVideo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.video.addEventListener('click', function () {
        var paused = _this._getVideoState();
        if (paused) {
          _this.video.play();
        } else {
          _this.video.pause();
        }
        _this._setButtonState(paused);
      });
      this._setButtonState(false);
    }
  }, {
    key: "_getVideoState",
    value: function _getVideoState() {
      return this.video.paused;
    }
  }, {
    key: "_setButtonState",
    value: function _setButtonState(videoState) {
      var playSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z"/></svg>';
      var pauseSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M520-200v-560h240v560H520Zm-320 0v-560h240v560H200Zm400-80h80v-400h-80v400Zm-320 0h80v-400h-80v400Zm0-400v400-400Zm320 0v400-400Z"/></svg>';
      if (videoState) {
        this.button.innerHTML = pauseSVG;
      } else {
        this.button.innerHTML = playSVG;
      }
    }
  }]);
  return EdVideo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-video', EdVideo);

/***/ }),

/***/ "./src/js/modules/ed-warranty.js":
/*!***************************************!*\
  !*** ./src/js/modules/ed-warranty.js ***!
  \***************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var EdWarranty = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdWarranty, _HTMLElement);
  var _super = _createSuper(EdWarranty);
  function EdWarranty() {
    _classCallCheck(this, EdWarranty);
    return _super.apply(this, arguments);
  }
  _createClass(EdWarranty, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this._adjustShape();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.container = this.querySelector('.ed-warranty-container');
      this.cornerPosition = this.dataset.cornerPosition || 'bottom-right';
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;
      this.resizeObserver = new ResizeObserver(function () {
        _this._adjustShape();
      });
      this.resizeObserver.observe(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "_adjustShape",
    value: function _adjustShape() {
      if (this.cornerPosition === 'none') {
        this.style.borderRadius = '';
        this.container.style.shapeOutside = '';
        return;
      }
      var width = this.offsetWidth;
      var height = this.offsetHeight;
      var X, radiusValue, shapeOutside;
      if (width > height) {
        X = (1 - (width - height + height / 2) / width) * 100;
        radiusValue = "".concat(X, "% 50%");
      } else {
        X = (1 - (height - width + width / 2) / height) * 100;
        radiusValue = "50% ".concat(X, "%");
      }
      switch (this.cornerPosition) {
        case 'top-left':
          this.style.borderTopLeftRadius = radiusValue;
          shapeOutside = "polygon(60% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 30%, 5% 15%, 10% 5%, 15% 0%)";
          break;
        case 'top-right':
          this.style.borderTopRightRadius = radiusValue;
          shapeOutside = "polygon(0% 0%, 40% 0%, 85% 5%, 90% 15%, 95% 30%, 100% 70%, 100% 100%, 0% 100%)";
          break;
        case 'bottom-left':
          this.style.borderBottomLeftRadius = radiusValue;
          shapeOutside = "polygon(0% 0%, 100% 0%, 100% 100%, 30% 100%, 15% 95%, 5% 85%, 0% 70%)";
          break;
        case 'bottom-right':
        default:
          this.style.borderBottomRightRadius = radiusValue;
          shapeOutside = "polygon(0% 100%, 0% 0%, 100% 0%, 100% 40%, 95% 70%, 90% 85%, 85% 95%, 80% 100%)";
          break;
      }
      this.style.borderRadius = '';
      this.style["border".concat(this.cornerPosition.split('-').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(''), "Radius")] = radiusValue;
      this.container.style.shapeOutside = shapeOutside;
    }
  }]);
  return EdWarranty;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-warranty', EdWarranty);

/***/ }),

/***/ "./src/js/modules/image-with-text-block.js":
/*!*************************************************!*\
  !*** ./src/js/modules/image-with-text-block.js ***!
  \*************************************************/
/***/ (() => {

function adjustImageWithTextBlockShape(element) {
  var imageWrapper = element.querySelector('.image-with-text-block__image-wrapper');
  var headingWrapper = element.querySelector('.ed-image-with-text-block__heading-wrapper');
  if (imageWrapper) {
    var alignment = imageWrapper.dataset.alignment;
    if (alignment === 'center') {
      return;
    }
    var width = imageWrapper.offsetWidth;
    var height = imageWrapper.offsetHeight;
    var X, radiusValue, clipPath;
    if (width > height) {
      X = (1 - (width - height + height / 2) / width) * 100;
      radiusValue = "".concat(X, "% 50%");
    } else {
      X = (1 - (height - width + width / 2) / height) * 100;
      radiusValue = "50% ".concat(X, "%");
    }
    imageWrapper.style.borderBottomRightRadius = '';
    imageWrapper.style.borderBottomLeftRadius = '';
    headingWrapper.style.clipPath = '';
    if (alignment === 'left') {
      imageWrapper.style.borderBottomRightRadius = radiusValue;
      clipPath = "polygon(0% 100%, 0% 0%, 100% 0%, 100% 40%, 95% 70%, 90% 85%, 85% 95%, 80% 100%)";
    } else if (alignment === 'right') {
      imageWrapper.style.borderBottomLeftRadius = radiusValue;
      clipPath = "polygon(0% 0%, 100% 0%, 100% 100%, 20% 100%, 15% 95%, 10% 85%, 5% 70%, 0% 40%)";
    }
    if (clipPath) {
      headingWrapper.style.clipPath = clipPath;
    }
  }
}
document.addEventListener('adjust-image-text-shape', function (event) {
  var element = event.detail.element;
  adjustImageWithTextBlockShape(element);
});
var resizeObserver = new ResizeObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.target.classList.contains('image-with-text-block')) {
      adjustImageWithTextBlockShape(entry.target);
    }
  });
});
document.querySelectorAll('.image-with-text-block').forEach(function (block) {
  resizeObserver.observe(block);
});

/***/ }),

/***/ "./src/js/modules/slideshow-stories.js":
/*!*********************************************!*\
  !*** ./src/js/modules/slideshow-stories.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SlideshowStories = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SlideshowStories, _HTMLElement);
  var _super = _createSuper(SlideshowStories);
  function SlideshowStories() {
    _classCallCheck(this, SlideshowStories);
    return _super.apply(this, arguments);
  }
  _createClass(SlideshowStories, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();
      this._attachListeners();
      this.onWindowResize();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.navigation = this.querySelector('.stories-nav');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      window.addEventListener('resize', this.onWindowResize.bind(this));
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (this.isOverflowing(this.navigation)) {
        this.navigation.classList.add('is-overflowing');
      } else {
        this.navigation.classList.remove('is-overflowing');
      }
    }
  }, {
    key: "isOverflowing",
    value: function isOverflowing(element) {
      return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }
  }]);
  return SlideshowStories;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('ed-slideshow-stories', SlideshowStories);

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-cart-upsell */ "./src/js/modules/ed-cart-upsell.js");
/* harmony import */ var _modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_cart_upsell_item__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-cart-upsell-item */ "./src/js/modules/ed-cart-upsell-item.js");
/* harmony import */ var _modules_ed_cart_upsell_item__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_upsell_item__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_slideshow_stories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/slideshow-stories */ "./src/js/modules/slideshow-stories.js");
/* harmony import */ var _modules_slideshow_stories__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_modules_slideshow_stories__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_ed_hide_pdp_images__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-hide-pdp-images */ "./src/js/modules/ed-hide-pdp-images.js");
/* harmony import */ var _modules_ed_hide_pdp_images__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_hide_pdp_images__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _modules_ed_upsell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-upsell */ "./src/js/modules/ed-upsell.js");
/* harmony import */ var _modules_ed_upsell__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_upsell__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-video */ "./src/js/modules/ed-video.js");
/* harmony import */ var _modules_ed_video__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-free-gift-handling */ "./src/js/modules/ed-free-gift-handling.js");
/* harmony import */ var _modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_free_gift_handling__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_image_with_text_block__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/image-with-text-block */ "./src/js/modules/image-with-text-block.js");
/* harmony import */ var _modules_image_with_text_block__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_image_with_text_block__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_warranty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-warranty */ "./src/js/modules/ed-warranty.js");
/* harmony import */ var _modules_ed_warranty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_warranty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_slideshow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-slideshow */ "./src/js/modules/ed-slideshow.js");
/* harmony import */ var _modules_ed_slideshow__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_slideshow__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_round_corner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-round-corner */ "./src/js/modules/ed-round-corner.js");
/* harmony import */ var _modules_ed_round_corner__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_round_corner__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _modules_ed_reviews_sync__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/ed-reviews-sync */ "./src/js/modules/ed-reviews-sync.js");
/* harmony import */ var _modules_ed_reviews_sync__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_reviews_sync__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _modules_ed_accessibility__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/ed-accessibility */ "./src/js/modules/ed-accessibility.js");
/* harmony import */ var _modules_ed_accessibility__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_accessibility__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _modules_ed_color_swatch_gallery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/ed-color-swatch-gallery */ "./src/js/modules/ed-color-swatch-gallery.js");
/* harmony import */ var _modules_ed_color_swatch_gallery__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_color_swatch_gallery__WEBPACK_IMPORTED_MODULE_13__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/















})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;